import { PageNav, NavTab } from "@ugg/shared/components/common/PageNav";
import { AppRoutes } from "@ugg/shared/routes/app-routes";
import { useActiveSpecialModes, SPECIAL_GAME_MODES } from "@ugg/shared/utils/special-game-modes";
import { tierListPageUrls } from "@ugg/shared/pages/tier-list-pages";
import { QueueTypeS } from "@ugg/shared/utils/queue-type-helpers";

export function TierListPageNav({ className }: { className?: string }) {
  const activeModes = useActiveSpecialModes({ ssr: true });

  const isAramMayehmActive = activeModes.findIndex((mode) => mode === QueueTypeS.ARAM_MAYHEM) !== -1;

  const specialModeTabs: NavTab[] = activeModes.map((mode) => {
    const { tierListPageName, tierListSettings, newTag } = SPECIAL_GAME_MODES[mode];
    return {
      to: tierListPageUrls[tierListPageName],
      // Nav shows a shorter label for ARAM Mayhem than the page title
      // ("ARAM Mayhem Tier List"); the page itself keeps the full title.
      label: mode === QueueTypeS.ARAM_MAYHEM ? "ARAM Mayhem" : tierListSettings.title.main,
      reset: true,
      new: newTag,
    };
  });

  const tabs: NavTab[] = [
    {
      to: AppRoutes.DEFAULT_TIER_LIST,
      label: "Tier List",
      activePaths: [
        AppRoutes.TOP_TIER_LIST,
        AppRoutes.JUNGLE_TIER_LIST,
        AppRoutes.MID_TIER_LIST,
        AppRoutes.ADC_TIER_LIST,
        AppRoutes.SUPPORT_TIER_LIST,
      ],
    },

    // Drew: Classic Tier List sits at the front of the special game modes
    // and is ALWAYS shown on the site — unlike the modes below it isn't
    // gated on a patch's tier-list data being live (its data is shipped
    // for launch), so it's a static tab rather than coming through
    // useActiveSpecialModes. Site-only for now: the desktop app has no
    // Classic tier-list route wired into the shared TierListRoutes yet
    // (it would fall through to the empty default page), so we hide the
    // tab in-app until an app implementation + QA pass lands.
    ...(process.env.UGG_PUBLIC_PLATFORM !== "app"
      ? [{ to: AppRoutes.CLASSIC_TIER_LIST, label: "Classic Tier List", reset: true, new: true }]
      : []),

    ...specialModeTabs,

    // Drew: We will show the augment tier list for the site, but not the app
    ...(process.env.UGG_PUBLIC_PLATFORM !== "app" && isAramMayehmActive
      ? [{ to: AppRoutes.ARAM_MAYHEM_AUGMENT_TIER_LIST, label: "Mayhem Augments", new: true }]
      : []),

    { to: AppRoutes.DUO_TIER_LIST, label: "Duo Tier List" },

    // Drew: We will hide Combat/Objectives for the site and keep it on the app
    ...(process.env.UGG_PUBLIC_PLATFORM !== "app"
      ? []
      : [
          { to: AppRoutes.COMBAT_TIER_LIST, label: "Combat" },
          { to: AppRoutes.OBJECTIVES_TIER_LIST, label: "Objectives" },
        ]),
  ];

  return <PageNav className={className} tabs={tabs} />;
}
